import React from "react";
import { TextComponent } from "./TextComponent";
import { urlBySinthiaFlores } from "../constants/utils";
import { Column } from "./Column";

interface EstilistasSectionProps {
	titulo: string;
	backgroundImage: string;
	description?: string;
}

export const StartSection: React.FC<EstilistasSectionProps> = ({ titulo, backgroundImage, description }) => (
	<div>
		<TextComponent
			variant="h4"
			className="w-full text-center py-2 text-black uppercase font-bold font-isabel"
		>
			Megabodas{" "}
			<a
				href={urlBySinthiaFlores}
				target="_blank"
				rel="noreferrer"
				className="underline text-primarySunset"
			>
				by Sinthia Flores
			</a>
		</TextComponent>
		<Column
			className="relative py-16 sm:py-28 bg-cover bg-center w-full gap-4 md:gap-8 px-4"
			style={{ backgroundImage: `url('${backgroundImage}')` }}
			crossAxisAlignment="center"
			mainAxisAlignment="center"
		>
			<div className="absolute w-full h-full bg-black/70" />
			<TextComponent
				variant="big"
				className="uppercase font-bold text-primaryPorcelain text-center font-isabel z-10"
				data-sal="slide-right"
				data-sal-duration="1500"
			>
				{titulo}
			</TextComponent>
			{description && (
				<TextComponent
					variant="h3"
					className=" md:w-1/2 text-center z-10 text-primaryBlush leading-5"
					data-sal="slide-left"
					data-sal-duration="1500"
				>
					{description}
				</TextComponent>
			)}
		</Column>
	</div>
);
